import React from 'react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';
import ConfigUtil from './util/config';

const initializeApp = (config) => {
    /* eslint-disable */
    global.gConfig = config;

    const domNode = document.getElementById('root');
    const root = createRoot(domNode);
    
    root.render(<App modulo={'polissonografia'} currentLanguage={'ptbr'} />);
}


Promise.all([
    fetch(`${process.env.PUBLIC_URL}/config/changelog.json`).then(response => response.json()),
    fetch(`${process.env.PUBLIC_URL}/config/config.json`).then(response => response.json())
])
    .then(async ([changelog, bootstrap]) => {
        const config = await ConfigUtil.resolverConfigInstancia(bootstrap);
        return [changelog, config];
    })
    .then(([changelog, config]) => {
        initializeApp(ConfigUtil.mesclarConfig(config, changelog, changelog.versoes[0]));
    })
    .catch(error => { console.error("Erro ao buscar os arquivos de configurações do frontend", error); });
serviceWorker.unregister();